/** @jsxRuntime classic */
/** @jsx jsx */
import { StaticImage } from 'gatsby-plugin-image';
import { jsx } from 'theme-ui';
import Ad from './Ad';

export default function AnkerAd(props: JSX.IntrinsicAttributes) {
  return (
    <Ad
      url="https://www.linauer.at/b2b"
      desktopImage={
        <StaticImage
          src="./Banner Desktop.png"
          width={728}
          height={90}
          alt="Anker Linauer"
        />
      }
      mobileImage={
        <StaticImage
          src="./Banner Mobil.png"
          width={300}
          height={200}
          alt="Anker Linauer"
        />
      }
      {...props}
    />
  );
}
